import { render, staticRenderFns } from "./ApplicantService.vue?vue&type=template&id=4bd6db33"
import script from "./ApplicantService.vue?vue&type=script&lang=ts"
export * from "./ApplicantService.vue?vue&type=script&lang=ts"
import style0 from "./ApplicantService.vue?vue&type=style&index=0&id=4bd6db33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports